export const FEATURES = {
    VIEW_DASHBOARD: 'VIEW_DASHBOARD',
    VIEW_WORKSHOPS: 'VIEW_WORKSHOPS',
    VIEW_SUPPLIERS: 'VIEW_SUPPLIERS',
    VIEW_AI_SEARCH: 'VIEW_AI_SEARCH',
    VIEW_INVOICES: 'VIEW_INVOICES',
    VIEW_QUOTATIONS: 'VIEW_QUOTATIONS',
    VIEW_REQUESTS: 'VIEW_REQUESTS',
    MANAGE_VEHICLES: 'MANAGE_VEHICLES',
    MANAGE_ACCESS: 'MANAGE_ACCESS'
};

export const DEFAULT_ROLE_PERMISSIONS = {
    'Car Owner': [
        FEATURES.VIEW_DASHBOARD,
        FEATURES.VIEW_WORKSHOPS,
        FEATURES.VIEW_INVOICES,
        FEATURES.VIEW_QUOTATIONS,
        FEATURES.MANAGE_VEHICLES
        // EXCLUDED: VIEW_SUPPLIERS, VIEW_AI_SEARCH
    ],
    'Car Workshop': [
        FEATURES.VIEW_DASHBOARD,
        FEATURES.VIEW_INVOICES,
        FEATURES.VIEW_QUOTATIONS,
        FEATURES.VIEW_REQUESTS,
        FEATURES.VIEW_SUPPLIERS
    ],
    'Admin': Object.values(FEATURES)
};
